import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document,$;

@Component({
  selector: 'app-revisions-in-progress',
  templateUrl: './revisions-in-progress.component.html',
  styleUrls: ['./revisions-in-progress.component.css']
})
export class RevisionsInProgressComponent implements OnInit {

  @ViewChild('myPond') myPond: any

    public despositionArray   : any = AppSettings.disposition;
    public documentTypeArray  : any = AppSettings.documentType;
    public loading            : any = false;
    public paginatePage       : any;
    public leads              : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];
    public agentsSub          : any;
    public agents                 : any;
    public qa                     : any;
    public loader                 : any;
    public completeDetailsloader  : any;
    public Rev_prog  : any = { id:null, note_updated:false, revision_note: '', attach: [], oldAttach: ''};

    public fileUploadLoader        : any = false;
    public markRevisionGallery     : any = [];
    public revisionStats             : any = {
      "invalid_revision_count": 0,
      "new_revision_count": 0,
      "revised_work_revision_count": 0
    };
    // public Rv_Attachment  : any;


    @ViewChild(DataTableDirective)
    public dtElement               : DataTableDirective;
    public dtOptions               : DataTables.Settings = {};
    public dtTrigger               : any = new Subject();

    public searchParams            : any = {emailId : '', writer: null, date_from: '', date_to:'',};
    public fullRangeDate           : any;
    public selectedDesposition     : any;
    public routeSaver              : any;
    public writers                 : any;
    public all_users               : any;
    public singleLead              : any;
    public bonusForm               : FormGroup;
    public bonusPercent            : any = ['-100', '-60', '-50', '-30', '-25', '-20', '-15', '-10', '0', '+10', '+15', '+20', '+25', '+30', '+50', '+60', '+100']
    public bonus                   : any = {bonus_ded: null, note: ''}
    public submitted               : any = false;
    public loaderBonus             : any;
    public bonusUpdated            : any;

    public notes                   : any;
    public addingNote              : any = false;

    public QA_Indx                 : any;
    public QA_Action               : any = { quality_note: '' };
    public QA_Loader               : any = false;
    public QA_Submitted            : any = false;

    // pondOptions1 = {
    //   allowMultiple: true,
    //   labelIdle: ` <p class='pond-label'> Drag & drop or <span> browse </span></p>`,
    //   allowImagePreview: true,
    // }

    pondOptions1 = {
      allowMultiple: true,
      labelIdle: ` <p class='pond-label'> Drag & drop or <span> browse </span></p>`,
      allowImagePreview: true,
      acceptedFileTypes:"image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf,",
      server: {
          url: AppSettings.API_ENDPOINT,
          timeout: 200000,
          process: {
              url: './admin/upload-temp-files',
              method: 'POST',
              withCredentials: false,
              timeout: 30000,
              onload: (response) => {
                let parsedData = JSON.parse(response);


                // console.log(this.Rev_prog.note_updated, this.Rev_prog.attach.length , this.Rev_FileLoader)
                // console.log("response.data******", response.data);
                let decrptedImg = this.helperService.decrypted(parsedData.data);
                let image = JSON.parse(decrptedImg);
                // console.log("image",image);

                // let name  = image.name;
                let id  = image.id;
                  this.pondFiles.push({file_name:image.file_name,id:image.id});
                  // Add image to pro image array
                  this.Rev_prog.attach = this.pondFiles;
                  this.markRevisionGallery.push(id);

                  console.log("this.Rev_prog",this.Rev_prog);
                  this.fileUploadLoader = false;
                  // console.log("markRevisionGallery" , this.markRevisionGallery);
                  return id;



              },
              onerror: (response) => {
                  return response.key;
              },
              ondata: (formData) => {
                  this.fileUploadLoader = true;
                  return formData;
              }
          },
          revert: (uniqueFileId, load, error) => {
              this.markRevisionGallery.splice(this.markRevisionGallery.indexOf(uniqueFileId), 1);
              // Clear Image
              load();
          },
          restore : null,
          load    : null,
          fetch   : null
      }
    }
    pondFiles = [];

    public DOC_URL                  : any = AppSettings.DOC_URL
    public docs_user_revion_path : any = AppSettings.docs_user_revion_path
    public docs_admin_revion_path : any = AppSettings.docs_admin_revion_path



    public Rev_FileLoader     : any = false;
    public Rev_UpdateLoader     : any = false;

    constructor(
      private helperService       : HelperService,
      private activatedRoute      : ActivatedRoute,
      private router              : Router,
      private agentsService       : Agents,
      private formBuilder         : FormBuilder,

    ) {
      // Get Agents
      this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
        if (agents) {
          this.agents     = agents.agents;
          this.qa         = agents.qa;
          this.writers    = agents.writers;
          this.all_users  = agents.all_users;

        }
      });
      this.fetchRevisionStats();
      this.routeSaver = this.router.url;

        this.dtOptions = {
          paging: true,
          info: true,
          // ordering: false,
          pagingType: 'full_numbers',
          pageLength: 10,
          serverSide: true,
          processing: true,
          searching: false,
          'language': AppSettings.dataTableLang,
          "columnDefs": [
            { "orderable": false,                           "targets": 0 },
            { "orderable": true,                            "targets": 1 },
            { "orderable": false,                           "targets": 2 },
            { "orderable": false,                           "targets": 3 },
            { "orderable": false,                           "targets": 4 },
            { "orderable": false,                           "targets": 5 },
            { "orderable": false,                           "targets": 6 },
            { "orderable": false,                           "targets": 7 },
            { "orderable": false,                           "targets": 8 },
            { "orderable": false,                           "targets": 9},
            { "orderable": false,                           "targets": 10},
            { "orderable": false,                           "targets": 11},
          ],
          "order": [[ 1, "desc" ]],
          ajax: (dataTablesParameters: any, callback) => {
            // Show Loader
            this.loading = true;
            // console.log("dataTablesParameters", dataTablesParameters);

            let url  = AppSettings.API_ENDPOINT + 'admin/get-revision-inprogress';

            let dtParams = {
                            order_id          : this.searchParams.emailId,
                            writer_id         : this.searchParams.writer,
                            date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                            date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                            work_type         : this.searchParams.work_type,
                            start             : dataTablesParameters.start,
                            length            : dataTablesParameters.length,
                            order             : dataTablesParameters.order,
                            columns           : dataTablesParameters.columns
                          };

            // For Record Serial Numbers
            this.paginatePage = dataTablesParameters.start;

            this.leads.data = [];

            this.helperService.httpPostRequestsDecryp(url, dtParams)
              .then( resp => {
                  this.leads        = JSON.parse(resp);
                  // console.log("this.leads", this.leads);

                  // Set Default page len
                  this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                  // Hide Loader
                  this.loading = false;

                  callback({
                    recordsTotal: this.leads.total,
                    recordsFiltered: this.leads.total,
                    // recordsFiltered: resp['recordsFiltered'],
                    // recordsFiltered: 1000,
                    data: []
                  });

                  // // $(".paginate_button .current").css("color", "white");
                  // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                  $('div.dataTables_length select').addClass('dt-form-control');
                  $('div.dataTables_filter input').addClass('dt-form-control');
              })
              .catch(error => {
                  // Set loader false
                  this.loading = false;

                  // // Rerender DT in case of failure
                  // this.rerender();

                  console.log("error: ",error);
              });
          },
          columns: [
            // { data: 'multiDelete' },
            { data: 'sr' },
            { data: 'id' },
            { data: 'clientInfo' },
            { data: 'pages' },
            { data: 'reason' },
            { data: 'writer' },
            { data: 'marked_by_Client_On' },
            { data: 'forwarded_to_writer_by' },
            { data: 'revision_ip_time' },
            { data: 'quality' },
            { data: 'bonus_deduction' },
            { data: 'comments' },
          ],
          // Use this attribute to enable the responsive extension
          responsive: false
        }
    }

    ngOnInit() {
      this.bonusForm = this.formBuilder.group({
        bonus_ded         : [null, Validators.required],
        note              : [null, Validators.required],
      });
    }

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();
      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
      }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate){
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }

      // console.log("this.fullRangeDate", this.fullRangeDate);
      //
      // console.log("this.searchParams.date_from", this.searchParams.date_from);
      // console.log("this.searchParams.date_to", this.searchParams.date_to);

      this.rerender();
    }

    showNotes(lead, index) {
      // Show Loader
      this.leads.data[index].loadingNotes = true;

      // Reset Notes
      this.notes = '';

      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o: lead.order_row_id, type: 'Revision-in-Progress' };
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments = resp;

            // Show Modal
            $("#notesModal_" + index).modal("show");
            $(".modal-backdrop").click(function() {
              $("#notesModal_" + index).modal("hide");
            });
          }

          // Hide Loader
          this.leads.data[index].loadingNotes = false;
      }).catch(err => {
          // Hide Loader
          this.leads.data[index].loadingNotes = false;
      });
    }

    addNotes(index, lead) {
      // Show Loader
      this.addingNote = true;

      let url = AppSettings.API_ENDPOINT + "shared/insert-note";
      let data = { id: lead.order_row_id, note: this.notes, type : 'Revision-in-Progress'};

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
              this.leads.data[index].view_notes = true;

              let self = this;
              this.leads.data[index].noteAdded = true;
              setTimeout(() => {
                self.leads.data[index].noteAdded = false;
              }, 1500);
          }

          // Hide Notes
          $("#notesModal_" + index).modal("hide");

          // Hide Loader
          this.addingNote = false;
      }).catch(err => {
          // Hide Loader
          this.addingNote = false;
      });
    }

    showComments(lead,index){
      // this.loader = true;
      // console.log("this.lead", lead);

      this.loader = lead.id;
      let type = 'Revision-in-Progress';
      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o : lead.order_row_id, type: type };
      this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined") {
          // console.log("resp", resp);
          this.comments = resp.data;

          if (this.comments.length == 0) {
            Swal.fire('No comments', "Agents and QA haven't added any comment yet." , 'info');
            this.loader = '';
          }
          else{
            if (typeof $ != "undefined") {
              this.loader = '';
              $("#comment_modal"+index).modal("show");
            }
          }
          $(".modal-backdrop").click(function(){
              $("#comment_modal"+index).modal("hide");
          });
        }

      });
    }

    agentSearch(id, agentArr) {
      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }
    }

    openBonusModal(lead){
      this.singleLead = lead;
      $("#bonus_modal").modal("show");
      this.bonus.note = lead.bonus_ded_note;
      this.bonus.bonus_ded = lead.per_bonus_ded;
    }
    get f(){return this.bonusForm.controls; }
    addBonus(){
      this.loaderBonus = true;

      // Set Submission True
      this.submitted        = true;

      // Stop here if form is invalid
      if (this.bonusForm.invalid) {
        this.loaderBonus = false;
       return;
      }

      let url = AppSettings.API_ENDPOINT + "admin/add-bonus-revision";
      let data = { oid: this.singleLead.order_row_id, bonus_ded: this.bonus.bonus_ded, bonus_ded_note: this.bonus.note};

      this.helperService.httpPostRequests(url, data).then(resp => {
          if(typeof resp != "undefined") {
            this.bonusUpdated = this.singleLead.order_row_id;
            this.submitted = false;
            this.loaderBonus = false;
            // console.log("resp", resp);
            $("#bonus_modal").modal("hide");
            this.leads.data.forEach(lead => {
              if(lead.order_row_id == this.singleLead.order_row_id){
                  lead.per_bonus_ded = this.bonus.bonus_ded;
                  lead.bonus_message = "Comp: Not Paid ("+this.bonus.bonus_ded+")";
              }
          });
          setTimeout(() => {
            this.bonusUpdated = '';
            this.singleLead = [];
            this.bonus = {bonus_ded: null, note: ''};
          }, 1000);
          }

          // Hide Loader
          this.submitted = false;
          this.loaderBonus = false;
      }).catch(err => {
          Swal.fire('', 'Something went wrong. Please try again', 'error');


          // Hide Loader
          this.submitted = false;
          this.loaderBonus = false;
      });

    }

    completeDetails(lead,index){

        // this.Rev_prog = lead;
        console.log("lead",lead)
        if (typeof $ != "undefined") {
          this.completeDetailsloader = '';
          $("#completeDetails_modal"+index).modal("show");

          $(".modal-backdrop").click(function(){
              $("#completeDetails_modal"+index).modal("hide");
          });
        }

        console.log("this.Rev_prog",this.Rev_prog);
             this.Rev_prog =   {    
                                    id:lead.id,
                                    note_updated : lead.revision_note != this.Rev_prog.revision_note,
                                    attach        : this.pondFiles,
                                    oldAttach     : lead.attach.split("~"),
                                    revision_note : lead.revision_note 
                                };
                                
        console.log("this.Rev_prog",this.Rev_prog);
              // this.Rv_Attachment = [];
              // Show Loader
              // this.leads.data[this.Rev_Index].loadingWork = true;
        
 
    }

    updateRevision(index){
      this.Rev_UpdateLoader = true;
      let url  = AppSettings.API_ENDPOINT + "support/edit-user-revision";
      let data = this.Rev_prog;
      this.helperService.httpPostRequests(url,data).then(resp => {
          // Set Previous data if any
          if(typeof resp != "undefined" && resp.status == 'OK') {
            this.pondFiles = [];
            this.Rev_prog = { id: '', note_updated:false, revision_note: '', attach: [], oldAttach: ''};
            
            this.Rev_UpdateLoader = false;
            this.rerender();
            $("#completeDetails_modal"+index).modal("hide");
          }
          console.log("this.Rev_prog: ", this.Rev_prog);

          
          // Remove all files
          // this.Writer_Pond_Attach.removeFiles();
          // this.Writer_Pond_Plag.removeFiles();

          // Open Modal
          // ($('#submitWork') as any).modal('show');

          // Hide Zip loader
          // this.leads.data[this.Rev_Index].loadingWork = false;
      }).catch(err => {
          // Hide Zip loader
            // this.leads.data[this.Rev_Index].loadingWork = false;
      });
    }

    openQualityModal(lead, index) {
      this.QA_Indx   = index;
      this.QA_Action = { quality_note: lead.quality_note };

      this.QA_Loader    = false;
      this.QA_Submitted = false;

      $("#_qulatity_modal"+index).modal("show");
      $(".modal-backdrop").click(function() {
        $("#_qulatity_modal"+index).modal("hide");
      });
    }

    submitQuality(index) {
      // Show Loader
      this.QA_Loader = true;

      let url = AppSettings.API_ENDPOINT + "admin/change-quality";
      let data = {
        oid           : this.leads.data[index].order_row_id,
        quality       : this.leads.data[index].quality == 1 ? 0 : 1,   // Inverse Quality
        quality_note  : this.QA_Action.quality_note
      };

      this.helperService.httpPostRequests(url, data).then(resp => {
        if (typeof resp != "undefined" && resp.status == "OK") {

          $("#_qulatity_modal"+index).modal("hide");

          // Set Quality
          this.leads.data[index].quality      = this.leads.data[index].quality == 1 ? 0 : 1;
          this.leads.data[index].quality_note = this.QA_Action.quality_note;

          this.leads.data[index].qualityUpdated = true;
          let self = this;
          setTimeout(() => {
            self.leads.data[index].qualityUpdated = null;
          }, 1000);
        }

        if (typeof resp != "undefined" && resp.status == "ERROR") {
          Swal.fire('', resp.message, 'error');
        }

        // Hide Loader
        this.QA_Loader = false;
      }).catch(err => {

        if (err.error)
          Swal.fire('', JSON.stringify(err.error.errors), 'error');

        // Hide Loader
        this.QA_Loader = false;
      });
    }


    clearFilters(){
      this.searchParams = {
                    emailId : '',
                    writer: null,
                    date_from: '',
                    date_to:'',
                    work_type:null
                  };
                  this.fullRangeDate = "";


      this.rerender();
    }

    pondHandleInit() {
      console.log('FilePond has initialised', this.myPond);
    }

    pondHandleAddFile(event: any) {
      console.log('A file was added', event);
    }

    pondHandleActivateFile(event: any) {
      console.log('A file was activated', event)
    }

    fetchRevisionStats() {
      let url = AppSettings.API_ENDPOINT + "support/revision-stats";
      
      this.helperService.httpPostRequestsDecryp(url, {}).then(resp => {
        console.log('Raw Response:', resp);
    
        // Check if response is a string, then parse it
        if (typeof resp === "string") {
          try {
            resp = JSON.parse(resp);
            console.log('Parsed Response:', resp);
          } catch (error) {
            console.error('Error parsing JSON:', error);
            return;
          }
        }
    
        if (resp && resp.data) {
          console.log('Revision Stats resp.data:', resp.data);
          this.revisionStats = resp.data; // Store response in variable
          console.log('Stored Revision Stats:', this.revisionStats); // Debugging
        } else {
          console.warn('resp.data is missing or falsy:', resp.data);
        }
      }).catch(error => {
        console.error('API Call Failed:', error);
      });
    }

    createFileUrl(attach: string): string {
      const arr = attach.split('/');
      if (arr.length > 1 && arr[0].length === 4 && arr[1].length === 2) {
      return this.DOC_URL + '/' + this.docs_admin_revion_path + '/' + attach;
      } else {
      return this.DOC_URL + '/' + this.docs_user_revion_path + '/' + attach;
      }
    }
  }
